import { Right } from "@insightfulscience/shared-utils/either";
/** @typedef {import("../interfaces/ISGApiClient").ISGApiClient} ISGApiClient */
/** @typedef {import("../interfaces/ISGApiClient").PlasmidSequences} PlasmidSequences */

/** @type {
	(query: string) =>
	(deps: { sgApiClient: ISGApiClient }) => Promise<Right<{ query: string, plasmid:PlasmidSequences[] }>>
} */
const searchPlasmid =
	(query) =>
	({ sgApiClient }) =>
		sgApiClient
			.searchPlasmid(query)
			.then((plasmid) => Right({ query, plasmid }));

export default searchPlasmid;
